import {gsap} from "gsap";

// ver 1
// gsap.set(".star", { opacity: 0, scale: 0.6, y: 10 });
// function animateStar(star, delay) {
//     gsap.timeline({ repeat: -1, repeatDelay: 1, delay: delay })
//         .to(star, { opacity: 1, scale: 1, y: 0, duration: 0.6, ease: "power2.out" })
//         .to(star, { y: "-=2", duration: 0.3, repeat: 3, yoyo: true, ease: "sine.inOut" }) // Легке мерехтіння
//         .to(star, { opacity: 0, scale: 0.6, y: 10, duration: 0.6, ease: "power2.in" });
// }
//
// animateStar(".star-1", 0);
// animateStar(".star-2", 0.3);
// animateStar(".star-3", 0.6);


$(document).ready(function () {
    if ($('.page-404').length > 0) {

        gsap.set([".star-1", ".star-2", ".star-3"], {scale: 0, opacity: 0});
        gsap.set([".star-stadami-1", ".star-stadami-2", ".star-stadami-3", ".star-stadami-4", ".star-stadami-5", ".star-stadami-6", ".star-stadami-7", ".star-stadami-8"], {
            scale: 0,
            opacity: 0,
        });

        function animateStars() {
            gsap.timeline({repeat: -1})
                .to([".star-1", ".star-2"], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-1", ".star-2"], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to(".star-3", {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to(".star-3", {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to(".star-1", {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to(".star-1", {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to(".star-2", {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to(".star-2", {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to([".star-1", ".star-3"], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-1", ".star-3"], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to([".star-2", ".star-3"], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-2", ".star-3"], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1});
        }

        function animateStarsStadami() {
            gsap.timeline({repeat: -1})
                .to([".star-stadami-3", ".star-stadami-5", ".star-stadami-8", ".star-stadami-7"], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-stadami-3", ".star-stadami-5", ".star-stadami-8", ".star-stadami-7"], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to([".star-stadami-1", ".star-stadami-2", ".star-stadami-4", ".star-stadami-6"], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-stadami-1", ".star-stadami-2", ".star-stadami-4", ".star-stadami-6"], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to([".star-stadami-2", ".star-stadami-3", ".star-stadami-4", ".star-stadami-6" ,".star-stadami-7"], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-stadami-2", ".star-stadami-3", ".star-stadami-4", ".star-stadami-6" ,".star-stadami-7"], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to([".star-stadami-3", ".star-stadami-4", ".star-stadami-5", ".star-stadami-6" ], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-stadami-3", ".star-stadami-4", ".star-stadami-5", ".star-stadami-6" ], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1})

                .to([".star-stadami-1", ".star-stadami-2", ".star-stadami-7", ".star-stadami-8" ], {scale: 1, opacity: 1, duration: 0.2, ease: "power2.inOut"})
                .to([".star-stadami-1", ".star-stadami-2", ".star-stadami-7", ".star-stadami-8" ], {scale: 0, opacity: 0, duration: 0.2, delay: 0.1});
        }

        animateStars();
        animateStarsStadami();
    }
});
